import { render } from 'preact';
import { App } from './components/App';
import { initApp } from './state/actions';
import '@fontsource-variable/bricolage-grotesque';
import '@fontsource-variable/ibm-plex-sans';
import '@fontsource-variable/jetbrains-mono';
import './styles.css';

const root = document.getElementById('app');
if (!root) throw new Error('Missing #app root element');

void initApp();
render(<App />, root);
